﻿import { ColumnsBase, fieldsProxy } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";
import { DocumentsRow } from "./Default.DocumentsRow";

export interface DocumentsColumns {
    Filename: Column<DocumentsRow>;
    Description: Column<DocumentsRow>;
    Type: Column<DocumentsRow>;
    CreatedOn: Column<DocumentsRow>;
    ReleaseDate: Column<DocumentsRow>;
    RevisionInfo: Column<DocumentsRow>;
}

export class DocumentsColumns extends ColumnsBase<DocumentsRow> {
    static readonly columnsKey = 'Default.Documents';
    static readonly Fields = fieldsProxy<DocumentsColumns>();
}